<template>
  <hel-module title="主要客户" :class="scope.clsPrefix">
    <div class="customer-container">
      <div
        class="customer-item"
        v-for="(item, index) in customerItems"
        :key="index"
      >
        <div class="item-name">{{ item.name }}</div>
        <div class="bar-wrapper">
          <div class="bar-track">
            <div class="bar-fill" :style="{ width: item.percent + '%' }"></div>
          </div>
        </div>
        <div class="item-value">{{ formatValue(item.value) }}</div>
        <span class="top-badge">TOP{{ item.ranking }}</span>
      </div>
    </div>
  </hel-module>
</template>

<script>
import HelModule from './common/module/index.vue'
import axios from 'axios'
export default {
  name: 'MainCustomers',
  components: {
    HelModule
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-main-customers'
      },
      customerItems: []
    }
  },
  mounted() {
    this.fetchMainCustomers()
  },
  methods: {
    formatValue(val) {
      // 接口金额单位为元，统一换算为万元展示：保留两位小数 + 千分位 + 「万」字
      const num = Number(val) / 10000
      return (
        num.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }) + '万'
      )
    },
    async fetchMainCustomers() {
      try {
        const response = await axios.post(
          'https://bigdata-cloud.cosmoplat.com/prod-api/system/api/call/erp/mainCustomers',
          {
            secret: '9k0NVP'
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )

        console.log('主要客户接口返回:', response.data)

        if (
          response.data.code === 200 &&
          Array.isArray(response.data.data)
        ) {
          // 字段映射层：统一映射为组件使用的字段
          this.customerItems = response.data.data.map((item) => ({
            ranking: item.ranking,
            name: item.customerName,
            value: item.amount,
            percent: Number(item.barRatio)
          }))
        }
      } catch (error) {
        console.error('获取主要客户数据失败:', error)
      }
    }
  }
}
</script>

<style lang="scss">
$class-prefix: "rvc-cosmoplat-workspace-main-customers";
.#{$class-prefix} {
  .customer-container {
    height: 100%;
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 2px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
  }
  .customer-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
  .item-name {
    flex-shrink: 0;
    width: 144px;
    font-family: PingFangSC-Medium;
    font-weight: 600;
    font-size: 12px;
    color: #333333;
  }
  .bar-wrapper {
    flex: 1;
    margin: 0 8px;
  }
  .bar-track {
    width: 100%;
    height: 6px;
    background: #f0f0f0;
    border-radius: 3px;
    overflow: hidden;
  }
  .bar-fill {
    height: 100%;
    border-radius: 3px;
    transition: width 0.5s ease;
    background: linear-gradient(90deg, #4eb9ff 0%, #7a63fe 100%);
  }
  .item-value {
    flex-shrink: 0;
    width: 76px;
    text-align: right;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #333333;
    font-weight: 400;
  }
  .top-badge {
    flex-shrink: 0;
    font-size: 12px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #73b950;
    background: #f1f8ed;
    padding: 2px 8px;
    border-radius: 10px;
  }
}
</style>
